import React from 'react'
import {
  activity_dates,
  costActivity,
  topNumber,
} from '../../../constants/activity-constants'
import terms_string from './terms-string'

export const getTerms = () => {
  return parseTerms(terms_string)
}

function parseTerms(termsString: string) {
  termsString = termsString
    .replaceAll('$startDate', activity_dates![0])
    .replaceAll('$endDate', activity_dates![1])
    .replaceAll('$cost', costActivity + '')
    .replaceAll('$top', topNumber + '')
    .replaceAll('startDate', activity_dates![0])
    .replaceAll('endDate', activity_dates![1])

  var TERMS: React.ReactNode[] = []
  // ================================================================================
  // ===================== APARTIR DE AQUI SE HACE EL TRATAMIENTO FORMATEO DE LA LISTA =======
  // ================================================================================
  /**
   *    SI HAY UNA LISTA DENTRO DELOS TERMINOS PON: <bullets> antes que empieze la lista
   *    la lista acaba cuando hay un salto de linea o inicia un titulo
   *
   *    SI HAY UNA SUB LISTA PAILAS que empieze cada sub item con  -  lo agregara al item ade la lista anterior lo va concatenando
   *
   *                                vease terminos colombia
   */
  // ================================================================================

  const pushLastToTerms = (content: any) => {
    const last = TERMS[TERMS.length - 1] as any[]
    last.push(content)
  }
  /**
   *  formatea el parrafo
   * @param {string} text
   * @returns
   */
  function formatParagrahpText(text: string) {
    const regex = /((http|https):\/\/[^\s]+)/g

    return text
      .split(' ')
      .join(' [space]')
      .split(' ')
      .map((word, idx) => {
        word = word.replace('[space]', ' ')
        // MATCH FOR LINK
        if (word.match(regex)) {
          return (
            <a
              key={'terms_link_' + idx + '_' + word.split(' ').join('')}
              href={word}
              target="_blank"
              rel="noreferrer"
              className="--link"
            >
              {word}
            </a>
          )
        }
        return word
      })
  }
  var bulletPoints: any[] = [],
    addBulletPoint = (data: any[]) => {
      if (data[0] === '-') {
        let lastitem = bulletPoints[bulletPoints.length - 1].pop()
        lastitem = lastitem.concat(<br />, data)
        bulletPoints[bulletPoints.length - 1].push(lastitem)
        return
      }
      bulletPoints[bulletPoints.length - 1].push(data)
    },
    endBulletPoints = () => {
      if (bulletPoints.length < 1) {
        return
      }
      let bullets = bulletPoints.pop()
      if (bullets.length < 1) {
        return
      }
      let rndId = () => Math.random().toString().replace('.', '')
      let id_bullets = Date.now() + '_' + rndId()

      pushLastToTerms(
        <ol key={'bullets_' + id_bullets}>
          {bullets.map((text: any, idx: number) => (
            <li key={'bullets_sub_' + id_bullets + '_' + idx}>{text}</li>
          ))}
        </ol>
      )
    }
  // digest string to title, paragrah first

  termsString.split('\n').forEach((text, idx) => {
    if (text.trim().length === 0) {
      endBulletPoints()
      return null
    }
    if (text.indexOf('O:') > -1) {
      endBulletPoints()
      // TITLE
      TERMS.push([])
      pushLastToTerms(<h5 key={'title_' + idx}>{text}</h5>)
      return
    }
    if (['<bullets>', '<list>'].includes(text)) {
      // ADD NEW LIST OF BULLET POINTS
      bulletPoints.push([])
      return
    }
    if (bulletPoints.length > 0) {
      addBulletPoint(formatParagrahpText(text))
      return
    }

    pushLastToTerms(
      <p key={'terms_paragraph_' + idx}>{formatParagrahpText(text)}</p>
    )
  })
  return TERMS
}
